import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/crm/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import TeamOverview from "@/pages/TeamOverview";
import Projects from "@/pages/Projects";
import Pitch from "@/pages/Pitch";
import WorkPipeline from "@/pages/WorkPipeline";
import TeamHub from "@/pages/TeamHub";
import Budget from "@/pages/Budget";
import HR from "@/pages/HR";
import Roles from "@/pages/Roles";
import ProjectOverview from "@/pages/ProjectOverview";
import Vendors from "@/pages/Vendors";
import VendorExpenses from "@/pages/VendorExpenses";
import InternalExpenses from "@/pages/InternalExpenses";
import ProjectPoc from "@/pages/ProjectPoc";
import ExpenseReports from "@/pages/ExpenseReports";
import FinanceSheet from "@/pages/FinanceSheet";
import Overheads from "@/pages/Overheads";
import ChatPage from "@/pages/ChatPage";
import ArtistWork from "@/pages/ArtistWork";
import Marketing from "@/pages/Marketing";
import Employees from "@/pages/Employees";
import Meetings from "@/pages/Meetings";
import Sales from "@/pages/Sales";
import Invoices from "@/pages/Invoices";
import PurchaseOrders from "@/pages/PurchaseOrders";
import Production from "@/pages/Production";
import HubPage from "@/pages/HubPage";
import AccountsPage from "@/pages/Accounts";
import { FinanceGate } from "@/components/crm/FinanceLock";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/team-overview" element={<TeamOverview />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/pitch" element={<Pitch />} />
            <Route path="/assignments" element={<WorkPipeline />} />
            <Route path="/tracker" element={<Navigate to="/assignments?stage=track" replace />} />
            <Route path="/handover" element={<Navigate to="/assignments?stage=handover" replace />} />
            <Route path="/execution" element={<Navigate to="/assignments?stage=execution" replace />} />
            <Route path="/approvals" element={<Navigate to="/assignments?stage=approvals" replace />} />
            <Route path="/team" element={<TeamHub />} />
            <Route path="/budget" element={<FinanceGate key="budget" title="Budget, Costing & P&L"><Budget /></FinanceGate>} />
            <Route path="/hr" element={<HR />} />
            <Route path="/roles" element={<Roles />} />
            <Route path="/overview" element={<ProjectOverview />} />
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/vendor-expenses" element={<VendorExpenses />} />
            <Route path="/internal-expenses" element={<InternalExpenses />} />
            <Route path="/poc" element={<ProjectPoc />} />
            <Route path="/expense-reports" element={<FinanceGate key="expense-reports" title="Expense Reports"><ExpenseReports /></FinanceGate>} />
            <Route path="/finance-sheet" element={<FinanceGate key="finance-sheet" title="Studio Finance Sheet"><FinanceSheet /></FinanceGate>} />
            <Route path="/overheads" element={<FinanceGate key="overheads" title="Studio Overheads"><Overheads /></FinanceGate>} />
            <Route path="/chat" element={<ChatPage />} />
            <Route path="/artists" element={<ArtistWork />} />
            <Route path="/marketing" element={<Marketing />} />
            <Route path="/employees" element={<Employees />} />
            <Route path="/meetings" element={<Meetings />} />
            <Route path="/sales" element={<Sales />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/purchase-orders" element={<PurchaseOrders />} />
            <Route path="/production" element={<Production />} />
            <Route path="/s/:hub/:section?" element={<HubPage />} />
            <Route path="/accounts/:section?" element={<AccountsPage key="accounts" />} />
            <Route path="/duty/:section?" element={<AccountsPage key="duty" duty />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" offset="84px" richColors />
    </AuthProvider>
  );
}

export default App;
